import { Controller } from "@hotwired/stimulus"

// Starts Inspectlet and ties the recording to at most one signed-in member,
// tagged with the pseudonym the admin drill-downs search on.
//
// Inspectlet queues commands on window.__insp and reads that queue once its
// script loads, so the order here is the contract: `resetSession` (which is a
// no-op after initialization) has to be queued before the website id, and the
// identity after it. That is also why the server asks Turbo to load the page
// fresh at every identity change (see inspectlet_identity_changed?): this
// controller can only end the previous member's recording while it is running
// in a runtime that hasn't initialized Inspectlet yet. Recording is deliberately
// left running for signed-out visitors — only the tagging is tied to a member.
export default class extends Controller {
  static values = { websiteId: Number, tag: String, identity: String, reset: Boolean }

  connect() {
    if (!this.websiteIdValue) return

    window.__insp = window.__insp || []
    if (this.resetValue) window.__insp.push(["resetSession"])
    window.__insp.push(["wid", this.websiteIdValue])
    this.loadScript()

    if (!this.identityValue || !this.tagValue) return

    window.__insp.push(["identify", this.identityValue])
    window.__insp.push(["tagSession", { [this.tagValue]: this.identityValue }])
  }

  loadScript() {
    if (window.__inspld) return

    window.__inspld = 1
    const script = document.createElement("script")
    script.async = true
    script.id = "inspsync"
    // Inspectlet's own snippet cache-busts hourly; keep that behavior.
    script.src = `https://cdn.inspectlet.com/inspectlet.js?wid=${this.websiteIdValue}&r=${Math.floor(Date.now() / 3600000)}`
    document.head.appendChild(script)
  }
}
